import styled from 'styled-components';

export default styled.div`
  display: block !important;
  background-color: yellow;
  border-radius: 30px;
  height: 30px;
  padding: 10px;
  vertical-align: middle;
  margin-bottom: 15px;
  .text {
    font-size: 15px;
    top: 10px;
    padding-top: 7.5px;
    display: inline-block;
  }
  &.error {
    background-color: red;
  }

  @keyframes blink-live {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
